import React from 'react';
import './DownloadPage.css';

function DownloadPage() {
  return (
    <div className="download-page">
      <div className="container">
        <h1>客戶端下載</h1>
        <div className="download-content">
          <div className="download-section">
            <h2>安卓客戶端 (32位)</h2>
            <div className="download-card">
              <div className="app-icon">
                <img src="/images/tvantlogo.png" alt="App Icon" />
              </div>
              <div className="app-info">
                <h3>螞蟻電視</h3>
                <p className="version">版本: 2.1.2</p>
                <p className="size">大小: 19.0 MB</p>
                <p className="update-date">更新日期: 2023</p>
              </div>
              <div className="download-button">
                <a href="/com.v2023.antv_2.1.2.apk" className="download-link">
                  下載
                </a>
              </div>
            </div>
          </div>

          <div className="download-section">
            <h2>安卓客戶端 (64位)</h2>
            <div className="download-card">
              <div className="app-icon">
                <img src="/images/tvantlogo.png" alt="App Icon" />
              </div>
              <div className="app-info">
                <h3>螞蟻電視</h3>
                <p className="version">版本: 2.1.3</p>
                <p className="size">大小: 19.3 MB</p>
                <p className="update-date">更新日期: 2025</p>
              </div>
              <div className="download-button">
                <a href="/com.v2025.antv.x64_2.1.3.apk" className="download-link">
                  下載
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownloadPage; 